import { Link } from 'react-router-dom'
import { Mail, Phone, MapPin, Globe, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const Footer = () => {
  const { t } = useTranslation()

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">{t('footer.companyName')}</h3>
            <p className="text-gray-400 mb-4">
              {t('footer.companyDesc')}
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="https://www.linkedin.com/in/pramod-sagar-0a9588135?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" className="text-gray-400 hover:text-white transition">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="https://www.instagram.com/ksd_ventures_pvt_ltd?igsh=MWR2ZWtpMHQ4NHhocg==" className="text-gray-400 hover:text-white transition">
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-white transition">{t('footer.home')}</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-white transition">{t('footer.aboutUs')}</Link></li>
              <li><Link to="/products/rice" className="text-gray-400 hover:text-white transition">{t('footer.products')}</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white transition">{t('footer.contact')}</Link></li>
              <li><Link to="/get-quote" className="text-gray-400 hover:text-white transition">{t('footer.getQuote')}</Link></li>
              <li><Link to="/become-partner" className="text-gray-400 hover:text-white transition">{t('footer.becomePartner')}</Link></li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.ourProducts')}</h3>
            <ul className="space-y-2">
              <li><Link to="/products/cattle-feed" className="text-gray-400 hover:text-white transition">{t('footer.cattleFeed')}</Link></li>
              <li><Link to="/products/rice" className="text-gray-400 hover:text-white transition">{t('footer.indianRice')}</Link></li>
              <li><Link to="/products/pulses" className="text-gray-400 hover:text-white transition">{t('footer.pulses')}</Link></li>
              <li><Link to="/products/spices" className="text-gray-400 hover:text-white transition">{t('footer.spices')}</Link></li>
              <li><Link to="/products/cereals" className="text-gray-400 hover:text-white transition">{t('footer.cereals')}</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.contactUs')}</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin className="h-5 w-5 mr-2 text-secondary flex-shrink-0" />
                <span className="text-gray-400">Sangamner, Dist. Ahilyanagar, Maharashtra, India</span>
              </li>
              <li className="flex items-center">
                <Mail className="h-5 w-5 mr-2 text-secondary flex-shrink-0" />
                <a href="mailto:ceo@ksdventures.com" className="text-gray-400 hover:text-white transition">
                  ceo@ksdventures.com
                </a>
              </li>
              <li className="flex items-center">
                <Globe className="h-5 w-5 mr-2 text-secondary flex-shrink-0" />
                <a href="https://www.ksdventures.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition">
                  www.ksdventures.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* International Offices */}
        <div className="mt-8 pt-8 border-t border-gray-800">
          <h3 className="text-lg font-semibold mb-4 text-center">{t('footer.internationalOffices')}</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-center">
            <div>
              <p className="font-semibold text-secondary">Ethiopia</p>
              <p className="text-gray-400">Addis Ababa</p>
            </div>
            <div>
              <p className="font-semibold text-secondary">Nigeria</p>
              <p className="text-gray-400">Lagos, Abuja</p>
            </div>
            <div>
              <p className="font-semibold text-secondary">UAE</p>
              <p className="text-gray-400">Dubai</p>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-gray-800 text-center text-gray-400">
          <p>&copy; {t('footer.copyright', { year: new Date().getFullYear() })}</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
